var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-bottom-bar"
  }, [_c('div', {
    staticClass: "row ugc-bottom-bar-buttons-wrapper"
  }, [_c('div', {
    staticClass: "small-6 large-6 columns ugc-bottom-bar-buttons-wrapper-go-back"
  }, [_c('button', {
    staticClass: "button secondary ugc-bottom-bar-cta",
    attrs: {
      "disabled": !_vm.enableGoBackButton,
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('go-back');
      }
    }
  }, [_vm._v(_vm._s(_vm.translations.ugcModalBack))])]), _c('div', {
    staticClass: "small-6 large-6 columns ugc-bottom-bar-buttons-wrapper-advance"
  }, [_c('button', {
    staticClass: "button primary ugc-bottom-bar-cta hide",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('next');
      }
    }
  }, [_vm._v(_vm._s(_vm.translations.ugcTopBarNext))]), _c('button', {
    class: ['button primary ugc-bottom-bar-cta', {
      hide: !_vm.showFinishButton
    }],
    attrs: {
      "disabled": !_vm.enableGoBackButton,
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('finish');
      }
    }
  }, [_vm._v(_vm._s(_vm.translations.ugcTopBarFinish))])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }